import React, { Component } from 'react';
import { ISceneConfig } from '../interfaces';
import { SceneEvents } from '../scenes/SceneEvents';
import { EmailSignup } from "./EmailSignup";
import { Mixpanel } from './Mixpanel';

import settings from '../data/settings_ramessesii_es.json';
import translations from '../data/translations.json';


interface Props {
  config: ISceneConfig,
}

export class WelcomeView extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    Mixpanel.track('User started guided tour', { tour: settings.slug });
    this.props.config.eventBus.emit(SceneEvents.StartGame);
  }

  render() {

    return (
      <div>

        <div className="cover-text scroll-text scroll-text-active fixed z-10 text-white w-full h-full" id="text0" style={{maxWidth: "50rem"}}>
          <div className="absolute full-cover-height w-screen h-screen inset-0 overflow-hidden bg-theme-900 top-0 left-0 right-0 bottom-0">
            <video
              className=" w-screen absolute left-0 right-0 full-cover-height w-screen h-screen object-cover"
              playsInline
              autoPlay
              muted
              loop
            >
              <source src={settings.intro_background_video} type="video/mp4"/>
            </video>
          </div>

          <div className="cover-text-gradient relative fixed w-screen h-screen top-0 left-0 right-0 bottom-0 bg-gradient-to-r from-theme-800 to-theme-900 opacity-70"></div>

          <div className="cover-text-content fixed w-screen h-screen top-0 left-0 right-0 bottom-0 px-4 flex flex-col items-center justify-center" style={{"WebkitTransform": "translate3d(0,0,0)"}}>
            <div className="cover-text-content-inner mx-auto w-full max-w-4xl flex flex-col h-full pt-24 sm:pt-36 md:pt-48 pb-24 justify-between">
              <div className="flex flex-col items-center justify-center text-center">
                <hr className="hidden md:block mused-hero-hr guided-tour-cover-hr h-px bg-theme-500 mx-auto mb-8 sm:mb-16 w-24 sm:w-full opacity-50" style={{maxWidth: "100%", opacity: "0.5"}}></hr>
                <h1 className="text-3xl font-thin font-serif text-white sm:text-5xl md:text-6xl lg:text-7xl text-shadow text-center block">{settings.title}</h1>

                <p className="text-base sm:text-xl my-8 sm:my-16 text-white text-shadow max-w-2xl mx-auto text-center">{settings.intro_text}</p>
              </div>

              {this.props.config ?
              <div className="text-center md:absolute bottom-12 md:bottom-24 md:left-0 md:right-0">
                <button className="block mt-4 md:mt-20 mx-auto bg-transparent hover:bg-theme-100 p-3 sm:p-6 rounded-full text-theme-100 hover:text-theme-800 image-annotation relative" onClick={this.onClick} style={{boxShadow: "none"}}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-8 h-8 p-2 relative scroll-indicator stroke-0" viewBox="0 0 16 16">
                    <path fill-rule="currentColor" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                  </svg>
                  <div className="focus-ring absolute top-0 left-0 right-0 bottom-0 opacity-100 w-full h-full border-theme-500 border border-solid rounded-full"></div>
                </button>
                <label className="block mt-6 italic text-white text-shadow opacity-90 text-base sm:text-md">{settings.enter_button_text}</label>
              </div>
              :
              <div className="text-center md:absolute bottom-12 md:bottom-24 md:left-0 md:right-0">
                <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
                <label className="block mt-6 italic text-white text-shadow opacity-90 text-base sm:text-md">{translations[settings.language]["Loading"]}</label>
              </div>
              }
            </div>


          </div>
        </div>
        <div className="hidden block text-base sm:text-xl md:text-2xl pb-2 sm:pb-4">
        </div>

        {/*<div className="fixed bottom-2 left-2 rounded-xl bg-theme-300 shadow-xl text-theme-700 text-xs sm:text-sm z-50 px-3 py-2">
          {translations[settings.language]["By entering this tour, you consent to our"]} <a href="https://mused.org/privacy/" className="underline hover:no-underline">{translations[settings.language]["cookie policy"]}</a>.
        </div>*/}
      </div>
    );
  }
}
